/**
 * @generated SignedSource<<cbd3c90af26118d1ee6afa92bedc3e30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TestScopesViewCountsFragment$data = {
  readonly failed: number | null | undefined;
  readonly ignored: number | null | undefined;
  readonly muted: number | null | undefined;
  readonly success: number | null | undefined;
  readonly " $fragmentType": "TestScopesViewCountsFragment";
};
export type TestScopesViewCountsFragment$key = {
  readonly " $data"?: TestScopesViewCountsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TestScopesViewCountsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TestScopesViewCountsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "success",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "failed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "muted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ignored",
      "storageKey": null
    }
  ],
  "type": "TestCounters",
  "abstractKey": null
};

(node as any).hash = "2131b4c675ea6d581e0f240d72bf1d65";

export default node;
